import permissions from '../permissions'

const PHISHING_LIST = [
  {
    name: 'Acessar indicadores',
    tag: permissions.PHISHING.DASHBOARD,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.PHISHING.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.PHISHING.MANAGE,
  },
]

export default PHISHING_LIST
